import axios from 'axios';

export const getEstadisticasPorAgencia = async (params = {}) => {
	try {
		const response = await axios.get('/estadisticasCRM/agencias', {
			params,
			retry: 3,
			retryDelay: 1000,
		});
		return response.data.data;
	} catch (error) {
		console.error('❌ Error en getEstadisticasPorAgencia:', error);
		throw error.response;
	}
};

export const getEstadisticasPorTrabajador = async (params = {}) => {
	try {
		const response = await axios.get('/estadisticasCRM/trabajadores', {
			params,
			retry: 3,
			retryDelay: 1000,
		});
		return response.data.data;
	} catch (error) {
		console.error('❌ Error en getEstadisticasPorTrabajador:', error);
		throw error.response;
	}
};

export const getEstadisticasCRM = async params => {
	try {
		const response = await axios.get('/estadisticasCRM', {
			params,
			retry: 3,
			retryDelay: 1000,
		});
		return response.data.data;
	} catch (error) {
		console.error('❌ Error en getEstadisticas:', error);
		throw error.response;
	}
};

export const getEstadisticas = async dias => {
	try {
		const response = await axios.get(`/estadisticas/${dias}`, {
			retry: 3,
			retryDelay: 1000,
		});
		return response.data.data;
	} catch (error) {
		console.error(
			'🚀 ~ file: estadisticas.js:8 ~ getEstadisticas ~ error:',
			error,
		);
		throw error.response;
	}
};

export const getEstadisticasPorRango = async data => {
	try {
		const response = await axios.post(`/estadisticas`, data, {
			retry: 3,
			retryDelay: 1000,
		});
		return response.data.data;
	} catch (error) {
		console.error(
			'🚀 ~ file: estadisticas.js:8 ~ getEstadisticas ~ error:',
			error,
		);
		throw error.response;
	}
};
